import React__default from 'react';
import _s from 'styled-components';
import Icon from './Icon.js';
import './global-2e5d81b9.js';
import './Box.js';
import './useTheme.js';

const styled = typeof _s === "object" && "default" in _s ? _s.default : _s;
const IconButton = ({
  name,
  color = 'primary',
  testID,
  onPress
}) => {
  return /*#__PURE__*/React__default.createElement(Container, {
    onClick: onPress
  }, /*#__PURE__*/React__default.createElement(Icon, {
    name: name,
    color: color,
    testID: testID
  }));
};
const Container = styled.a`
  cursor: pointer;
  outline: none;
  display: inline-block;

  &:hover {
    opacity: 0.75;
  }
`;

export { IconButton as default };
//# sourceMappingURL=IconButton.js.map
